import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
  label?: string;
  href?: string;
}
export function CTAButton({
  className = '',
  onClick,
  label = '¡SÍ, QUIERO EL PROTOCOLO AHORA!',
  href
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05,
    boxShadow: '0px 10px 25px rgba(212, 114, 92, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick || (() => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      const el = document.getElementById('offer');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  })} className={`bg-brand-coral text-white font-sans font-semibold py-4 px-8 md:px-12 rounded-full shadow-lg transition-colors hover:bg-brand-coralHover text-lg tracking-wide ${className}`} data-id="element-101">
      {label}
    </motion.button>;
}